module.exports = "precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nvarying vec2 vUv;\n\nvoid main() {\n  gl_FragColor = texture2D(texture, vUv);\n\n  if (gl_FragColor.w < 0.5) {\n    discard;\n  }\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./~/glslify-loader!/Users/songseunggeun/voxeline/engine/shaders/custom.frag
 ** module id = 771
 ** module chunks = 0
 **/